// 오늘을 기준으로 7일간의 날짜 생성
export const getWeekDates = () => {
  const today = new Date()
  const currentDay = today.getDay() // 0: 일요일, 1: 월요일, ..., 6: 토요일
  const mondayOffset = currentDay === 0 ? -6 : 1 - currentDay // 월요일까지의 거리
  const monday = new Date(today.getTime() + mondayOffset * 24 * 60 * 60 * 1000)

  return Array.from({ length: 7 }, (_, i) => {
    const date = new Date(monday.getTime() + i * 24 * 60 * 60 * 1000)
    return date.toISOString().split('T')[0] // YYYY-MM-DD 형태
  })
}
// 오늘 날짜를 YYYY-MM-DD 형식으로 가져오기
export const getTodayDate = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
